// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"Vz-z","smallCardRow":"Wz-z","largeCardRow":"Xz-z","productSearchRow":"Yz-z","curatedRow":"Zz-z"};